import loadable from '@loadable/component';

export const RugbyworldSiteWrapper = loadable(
  () => import(/* webpackChunkName: "rugbyworld-site" */ './RugbyworldSiteWrapper'),
);
